import { useState, useEffect } from "react";
import axios from "axios";
import useAxiosConfig from "../../../../config/useAxiosConfig";

const useAccountProfile = (schoolId) => {
  const { loading: axiosLoading, error, postData: apiPost } = useAxiosConfig();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`/AdminMouMember/${schoolId}`);
        setData(response.data?.rows || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      }
    };

    if (!axiosLoading) {
      fetchData();
    }
  }, [axiosLoading]);

  const sendSchoolNotification = async (schoolId, subject) => {
    try {
      const response = await axios.put(
        `/SchoolNotificationMember/${schoolId}`,
        subject
      );
      return response.data;
    } catch (error) {
      console.error("Error Sending Notification:", error);
      throw error;
    }
  };

  return {
    data,
    loading,
    sendSchoolNotification,
  };
};
export default useAccountProfile;
